import React from 'react'
import "./banner.css"
import BannerBg1 from "../../assets/images/home-banner.png"
import { Button, Col, Container, Image, Row } from 'react-bootstrap'
import Slider from 'react-slick'

const Banner = () => {
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: "linear"
    };
    return (
        <div className='home-banner'>
            <Slider {...settings}>
                <div className='banner-slider position-relative d-flex align-items-center'>
                    <div className='banner-bg'>
                        <Image src={BannerBg1} alt='banner-bg' fluid className='h-100' />
                    </div>
                    <Container fluid className='custom-container h-100 d-flex align-items-center justify-content-end'>
                        <Row className='w-100 justify-content-end'>
                            <Col lg={6}>
                                <div className='content-wrapper text-white text-center'>
                                    <div className='heading-wrapper'>
                                        <h1 className='h1 mb-0'>
                                            Bespoke Beauty
                                        </h1>
                                        <p className=''>Elevate your wardrobe with custom fabric</p>
                                    </div>
                                    <Button className='yellow-btn'>
                                        Shop Now
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className='banner-slider position-relative d-flex align-items-center'>
                    <div className='banner-bg'>
                        <Image src={BannerBg1} alt='banner-bg' fluid className='h-100' />
                    </div>
                    <Container fluid className='custom-container h-100 d-flex align-items-center justify-content-end'>
                        <Row className='w-100 justify-content-end'>
                            <Col lg={6}>
                                <div className='content-wrapper text-white text-center'>
                                    <div className='heading-wrapper'>
                                        <h1 className='h1 mb-0'>
                                            Bespoke Beauty
                                        </h1>
                                        <p className=''>Elevate your wardrobe with custom fabric</p>
                                    </div>
                                    <Button className='yellow-btn'>
                                        Shop Now
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className='banner-slider position-relative d-flex align-items-center'>
                    <div className='banner-bg'>
                        <Image src={BannerBg1} alt='banner-bg' fluid className='h-100' />
                    </div>
                    <Container fluid className='custom-container h-100 d-flex align-items-center justify-content-end'>
                        <Row className='w-100 justify-content-end'>
                            <Col lg={6}>
                                <div className='content-wrapper text-white text-center'>
                                    <div className='heading-wrapper'>
                                        <h1 className='h1 mb-0'>
                                            Bespoke Beauty
                                        </h1>
                                        <p className=''>Elevate your wardrobe with custom fabric</p>
                                    </div>
                                    <Button className='yellow-btn'>
                                        Shop Now
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Slider>
        </div>
    )
}

export default Banner